import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import VueParticles from 'vue-particles'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/reset.css'
// import './assets/css/style.css'
import VueCookies from 'vue-cookies'
import 'intersection-observer'
import VueLazyLoad from 'vue-lazyload'
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css'
// import AMap from 'vue-amap';
// Vue.use(AMap);
// AMap.initAMapApiLoader({
//   key: '7d2ac6105bb67f7a5af1ca75d38537dc',
//   plugin: ['AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'Geolocation', 'AMap.MapType']
// });
import BaiduMap from 'vue-baidu-map';
Vue.use(BaiduMap, {
  ak: '0oXqX0dVbCG0HAs12sk5a3RwQmO8KoF8'
})

Vue.use(VueCookies)
Vue.config.productionTip = false
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
Vue.use(VueLazyLoad)
Vue.use(Element, {
  size: 'small'
})
Vue.use(VueParticles)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js